function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-686-3902h1920v6415H-686z"
}), React.createElement("path", {
  d: "M-686-3583h1920v6041H-686z"
}), React.createElement("g", {
  transform: "translate(-70 -52)"
}, React.createElement("g", {
  transform: "translate(78.75 61.053)",
  fill: "currentColor"
}, React.createElement("path", {
  d: "M39.17 27.275h4.493l-2.334 4.669a1.025 1.025 0 1 0 1.834.917l3.076-6.153a1.025 1.025 0 0 0-.917-1.483H40.83l2.334-4.669a1.025 1.025 0 1 0-1.834-.917l-3.076 6.153a1.025 1.025 0 0 0 .917 1.483zM26.25 19.072H7.793c-.566 0-1.025.46-1.025 1.026v12.304c0 .567.459 1.026 1.025 1.026H26.25c.566 0 1.025-.46 1.025-1.026V20.098c0-.567-.459-1.026-1.025-1.026zm-1.025 12.305h-4.102V26.25a1.025 1.025 0 0 0-2.05 0v5.127H14.97V26.25a1.025 1.025 0 0 0-2.051 0v5.127H8.818V21.123h16.407v10.254z"
}), React.createElement("path", {
  d: "M51.475 3.076c-.567 0-1.026.46-1.026 1.026v4.212a7.155 7.155 0 0 0-5.127-2.162h-14.97V1.025C30.352.46 29.892 0 29.326 0h-6.152c-.566 0-1.026.46-1.026 1.025v5.127h-4.101V1.025C18.047.46 17.587 0 17.02 0H10.87c-.566 0-1.025.46-1.025 1.025v5.127H7.178A7.155 7.155 0 0 0 2.05 8.314V4.102a1.025 1.025 0 0 0-2.051 0v41.22c0 .566.46 1.026 1.025 1.026h5.817c.5 3.473 3.494 6.152 7.103 6.152 3.61 0 6.604-2.679 7.104-6.152h17.487l2.793 5.585c.174.348.529.567.917.567h6.152c.567 0 1.026-.46 1.026-1.025v-5.127h2.05c.567 0 1.026-.46 1.026-1.026V4.102c0-.567-.46-1.026-1.025-1.026zM24.199 2.051h4.102v4.101h-4.102V2.051zm-12.304 0h4.101v4.101h-4.101V2.051zm2.05 48.398a5.133 5.133 0 0 1-5.127-5.127c0-2.827 2.3-5.127 5.127-5.127s5.127 2.3 5.127 5.127-2.3 5.127-5.127 5.127zm33.428 0H42.88l-2.051-4.101h6.544v4.101zm3.076-6.152h-29.4c-.5-3.474-3.494-6.152-7.104-6.152s-6.604 2.678-7.103 6.152H2.051V14.355h10.356a1.025 1.025 0 0 0 0-2.05H2.154a5.136 5.136 0 0 1 5.024-4.102h38.144a5.136 5.136 0 0 1 5.024 4.102h-28.71a1.025 1.025 0 0 0 0 2.05h10.356v24.2c0 .566.46 1.025 1.026 1.025h17.431v4.717zm0-6.768H34.043V14.355h16.406V37.53z"
}), React.createElement("circle", {
  cx: 17.021,
  cy: 13.33,
  r: 1.025
}))), React.createElement("text", {
  fontFamily: "BNPPSans, BNPP Sans",
  fontSize: 16,
  transform: "translate(-70 -56.72)"
}, React.createElement("tspan", {
  x: 70.952,
  y: 138.719
}, "Agregator")));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 70,
    height: 71
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/agregator.48400d58.svg";
export { SvgComponent as ReactComponent };